<script>
import BadgeGroup from '@/components/BadgeGroup';

export default {
  extends: BadgeGroup,
  props: {
    product: {
      type: Object,
      required: true,
    },
    isB2bPdp: Boolean,
  },
  mounted() {
    this.badgeList = this.productBadges;
  },
  computed: {
    productBadges() {
      let tempList = [];
      if (this.product.isArchived) {
        tempList.push({
          text: this.bp('productArchivedFlag'),
          class: 'text-black',
          qaid: `${this.qaid}${this.toQaid(this.bp('productArchivedFlag'))}Badge`,
        });
      }

      //PLP & B2C
      if (this.product.saleFlag && !this.isB2bPdp) {
        tempList.push({
          text: this.bp('productSaleFlag'),
          class: 'text-red',
          qaid: `${this.qaid}${this.toQaid(this.bp('productSaleFlag'))}Badge`,
        });
      }

      //Required for B2B-PDP as backend is sending productBadgeStatus to identify badge on status.
      if (this.isB2bPdp) {
        if (this.product.productBadgeStatus == 'S') {
          tempList.push({
            text: this.bp('productSaleFlag'),
            class: 'text-red',
            qaid: `${this.qaid}${this.toQaid(this.bp('productSaleFlag'))}Badge`,
          });
        }

        if (this.product.productBadgeStatus == 'E') {
          tempList.push({
            text: this.bp('productEarlyIntroFlag'),
            class: 'text-black',
            qaid: `${this.qaid}${this.toQaid(this.bp('productEarlyIntroFlag'))}Badge`,
          });
        }

        if (this.product.productBadgeStatus == 'C') {
          tempList.push({
            text: this.bp('productCloseoutFlag'),
            class: 'text-warning',
            qaid: `${this.qaid}${this.toQaid(this.bp('productCloseoutFlag'))}Badge`,
          });
        }
      }

      if (this.product.productCallout && this.product.productCallout.length > 0) {
        if (this.product.productCallout.toLowerCase() === 'new') {
          tempList.push({
            text: this.bp('productNewFlag'),
            class: 'text-black',
            qaid: `${this.qaid}${this.toQaid(this.bp('productNewFlag'))}Badge`,
          });
        } else {
          tempList.push({
            text: this.product.productCallout,
            class: 'text-black',
            qaid: `${this.qaid}${this.toQaid(this.product.productCallout)}Badge`,
          });
        }
      }

      return tempList;
    },
  },
};
</script>
